// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"_29ZnYnEL8Ua2BkGmiG5e9_"};